import React, { PureComponent } from 'react';
import { translationPropType } from '@eb/i18n';
import Template from './_internal/Template';
import BannerContent from './_internal/BannerContent';

import './actionBanner.scss';

const BOTTOM_BANNER_CLASSES =
    'marketing-action-banner marketing-container__max-width--wide eds-g-cell eds-g-cell-6-12 eds-l-pad-vert-16 eds-text--center';
const BOTTOM_BANNER_CONTENT_CONTAINER_CLASSES = 'eds-align--center-vertical';
const BOTTOM_BANNER_CONTENT_CLASSES =
    'eds-l-pad-sn-all-6 eds-l-pad-sm-all-6 eds-align--center eds-align--center-vertical';

const ActionBannerContent = ({
    CTA,
    CTAStyle,
    onClick,
    description,
    heading,
    secondaryHeading,
}) => (
    <div className={BOTTOM_BANNER_CLASSES}>
        <section className={BOTTOM_BANNER_CONTENT_CONTAINER_CLASSES}>
            <div className={BOTTOM_BANNER_CONTENT_CLASSES}>
                <BannerContent
                    CTA={CTA}
                    CTAStyle={CTAStyle}
                    customHeadingSize="eds-text-hm"
                    onClick={onClick}
                    heading={heading}
                    secondaryHeading={secondaryHeading}
                    description={description}
                    contentTextColor="white"
                    additionalCTAClassNames="eds-l-mar-top-10"
                />
            </div>
        </section>
    </div>
);

export default class ActionBanner extends PureComponent {
    static propTypes = {
        /*
        Main title
        */
        heading: translationPropType,
        /*
        Secondary heading
        */
        secondaryHeading: translationPropType,
        /*
        Description to follow headings
        */
        description: translationPropType,
        /*
        CTA for button
        */
        CTA: translationPropType,
    };

    render() {
        const {
            CTA,
            CTAStyle,
            onClick,
            description,
            heading,
            secondaryHeading,
        } = this.props;

        return (
            <div className="eds-g-grid">
                <Template hasPadding={false} bgColor="ui-orange">
                    <ActionBannerContent
                        CTA={CTA}
                        CTAStyle={CTAStyle}
                        onClick={onClick}
                        description={description}
                        heading={heading}
                        secondaryHeading={secondaryHeading}
                    />
                </Template>
            </div>
        );
    }
}
